import { render, staticRenderFns } from "./Forecasting.vue?vue&type=template&id=0a0fdc48"
import script from "./Forecasting.vue?vue&type=script&lang=js"
export * from "./Forecasting.vue?vue&type=script&lang=js"
import style0 from "./Forecasting.vue?vue&type=style&index=0&id=0a0fdc48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports